__turbopack_context__.v({
  "className": "neuehaas_e8810f8e-module__p3pv3q__className",
  "variable": "neuehaas_e8810f8e-module__p3pv3q__variable",
});
